import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6272da6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-18 ant-col-xs-18" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-3 ant-col-xs-6 ant-col-lg-6" }, null, -1))
const _hoisted_4 = {
  class: "ant-col ant-col-xl-3 ant-col-xs-3 ss-ocultar-mobile",
  style: {"padding-right":"10px"}
}
const _hoisted_5 = { class: "ant-table-column-title" }
const _hoisted_6 = { class: "ant-table-column-sorter ant-table-column-sorter-full" }
const _hoisted_7 = { class: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "Ordenar crescente",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-up",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "caret-down",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-down",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
  ])
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 2,
  class: "acoes-item"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = {
  key: 6,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_26 = {
  class: "ant-input-affix-wrapper ss-paginacao-qtde-registros",
  style: {"margin-top":"0px"}
}
const _hoisted_27 = { class: "ant-input-suffix" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1))
const _hoisted_29 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_radio_group, {
          value: _ctx.computedVisualizacaoKanban,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedVisualizacaoKanban) = $event)),
          "button-style": "solid"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, {
              value: true,
              style: {"padding-top":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, { nome: "mapa" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, {
              value: false,
              style: {"padding-top":"5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icone, { nome: "menu" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createVNode(_component_a_table, {
      style: {"margin-top":"5px"},
      columns: _ctx.state.colunas.filter(item => item.visible),
      "data-source": _ctx.computedDevolucoes,
      rowKey: "codigo",
      pagination: false,
      loading: _ctx.telaBase.carregando,
      scroll: _ctx.state.telaMobile ? null : { y: _ctx.window.innerHeight },
      "row-selection": { selectedRowKeys: _ctx.computedSelecionados, onChange: _ctx.mudarSelecao },
      size: "small"
    }, {
      headerCell: _withCtx(({ column }) => [
        (column.ordering)
          ? (_openBlock(), _createElementBlock("div", {
              key: column.key,
              class: "ss-coluna-ordenada"
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(column.title), 1),
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(), _createElementBlock("a", {
                    title: "Ordenação crescente",
                    key: 'ord-asc' + column.key,
                    class: _normalizeClass([_ctx.ordenacaoAtiva(column.key, 'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                    onClick: ($event: any) => (_ctx.ordenarDados(column.key, 'ASC'))
                  }, _hoisted_10, 10, _hoisted_8)),
                  (_openBlock(), _createElementBlock("a", {
                    title: "Ordenação decrescente",
                    key: 'ord-desc' + column.key,
                    class: _normalizeClass([_ctx.ordenacaoAtiva(column.key, 'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                    onClick: ($event: any) => (_ctx.ordenarDados(column.key, 'DESC'))
                  }, _hoisted_13, 10, _hoisted_11))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      bodyCell: _withCtx(({ column, text, index, record }) => [
        (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: ($event: any) => (_ctx.visualizar(index))
            }, [
              _createElementVNode("span", null, _toDisplayString(text), 1)
            ], 8, _hoisted_14))
          : (column.key === 'Status')
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 1,
                class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(text))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(text), 1)
                ]),
                _: 2
              }, 1032, ["class"]))
            : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("a", {
                    class: "visualizar",
                    onClick: ($event: any) => (_ctx.visualizar(index))
                  }, [
                    _createVNode(_component_icone, { nome: "visualizar" })
                  ], 8, _hoisted_16),
                  _createElementVNode("a", {
                    class: "imprimir",
                    onClick: ($event: any) => (_ctx.imprimir(index))
                  }, [
                    _createVNode(_component_icone, { nome: "imprimir" })
                  ], 8, _hoisted_17)
                ]))
              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                    : (column.key === 'DevolucaoVenda')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("span", null, [
                            _createElementVNode("b", null, [
                              _createElementVNode("a", {
                                onClick: ($event: any) => (_ctx.visualizar(index))
                              }, [
                                _createElementVNode("span", null, "Devolução " + _toDisplayString(record.numero), 1)
                              ], 8, _hoisted_22)
                            ])
                          ]),
                          _createElementVNode("span", null, "Nota " + _toDisplayString(record.numeroNotaFiscal) + " do dia " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(record.dataEmissao)), 1),
                          _createElementVNode("span", null, _toDisplayString(record.nomeRazaoSocialEmitente), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.totalNotaFiscal, 2)), 1),
                          _createElementVNode("span", null, [
                            _createVNode(_component_a_tag, {
                              class: _normalizeClass('ss-tag-status ' + _ctx.obterClasseStatus(record.descricaoStatus))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(record.descricaoStatus), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
      ]),
      emptyText: _withCtx(() => [
        _createVNode(_component_mensagem_sem_dados, {
          resultadoPesquisa: !_ctx.telaBase.carregando,
          mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
        }, null, 8, ["resultadoPesquisa", "mensagem"])
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_a_pagination, {
          class: "ss-paginacao-completa",
          current: _ctx.computedPaginacao.current,
          "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedPaginacao.current) = $event)),
          size: "small",
          total: _ctx.state.paginacaoApi.totalRegistros,
          "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} registros`,
          "page-size": _ctx.computedPaginacao.pageSize,
          pageSizeOptions: _ctx.computedPaginacao.pageSizeOptions,
          onShowSizeChange: _ctx.mostrarNovaPagina,
          onChange: _ctx.mudarPagina
        }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("span", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.totalRegistrosComMascara) = $event)),
            onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.alterarQuantidadeRegistroTotal(($event.target as HTMLInputElement).value))),
            placeholder: "Total registros",
            type: "text",
            class: "ant-input hidden"
          }, null, 544), [
            [_vModelText, _ctx.state.totalRegistrosComMascara],
            [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
          ]),
          _createElementVNode("span", _hoisted_27, [
            _createVNode(_component_a_tooltip, { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_28
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_29, [
                  _createVNode(_component_icone, { nome: "informacoes" })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}